/**
 * zodパース時に両端の全角半角スペース削除
 * 使い方: z.string().transform((val) => fullTrim(val.trim()))
 */
export const fullTrim = (str: string) =>
  str.replace(/^[\s\u3000]+|[\s\u3000]+$/g, "");